import React from "react";

import { CircleSkeleton, RectSkeleton } from "shipnow-mercurio";

import { Styles } from "./CircleAndRectSkeleton.styles";

export const CircleAndRectSkeleton = () => {
  return (
    <Styles.Wrapper>
      <Styles.ImageWrapper>
        <CircleSkeleton margin="r-16" size="sm" />
      </Styles.ImageWrapper>

      <RectSkeleton size="lg" width="70%" />
    </Styles.Wrapper>
  );
};
